// Table column definitions for Backfill list
import { createColumnHelper } from '@tanstack/react-table';
import type { BackfillExecutions } from '../types/backfill.types';
import BackfillErrorStatusModal from './statusModal/BackfillErrorStatusModal';

const columnHelper = createColumnHelper<BackfillExecutions>();

export const createBackfillColumns = () => [
  columnHelper.accessor('id', {
    header: () => 'Backfill ID',
    cell: info => <div className="w-32 truncate">{info.getValue()}</div>,
    size: 60,
  }),
  columnHelper.accessor('startTime', {
    header: () => 'Start Time',
    cell: info => <div className="w-40 truncate">{info.getValue()}</div>,
    size: 80,
  }),
  columnHelper.accessor('endTime', {
    header: () => 'End Time',
    cell: info => <div className="w-40 truncate">{info.getValue()}</div>,
    size: 80,
  }),
  columnHelper.accessor('status', {
    header: () => 'Status',
    cell: info => {
      const error = info.getValue();
      const row = info.row.original;
      return error ? <BackfillErrorStatusModal execution={row} /> : null;
    },
    size: 80,
  }),
];

export const backfillColumns = createBackfillColumns();
